import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    //  padding: theme.spacing(1, 2),
    //height:100
    padding: 5,
    margin: 15
  },
}));

function PaperSheetCustom(props) {
  const classes = useStyles();
  var pageClasses = [classes.root, props.className];
  return (
    <Paper className={pageClasses}>
      <Typography variant="title" color="primary">
        {props.title}
      </Typography>
      {props.children}
    </Paper>
  );
}

export {PaperSheetCustom}
